import { djs } from '@duke-hq/djs';

// "4 min ago", "Today 10:42", "2 days ago", "9 Oct", "9 Oct 2025"
export function formatLastRunAt(at: Date, now: Date = new Date()): string {
  const atDjs = djs(at);
  const nowDjs = djs(now);
  const minutes = nowDjs.diff(atDjs, 'minute');
  if (minutes < 1) {
    return 'Just now';
  }
  if (minutes < 60) {
    return `${minutes} min ago`;
  }
  if (atDjs.isSame(nowDjs, 'day')) {
    return `Today ${atDjs.format('HH:mm')}`;
  }
  const days = nowDjs.startOf('day').diff(atDjs.startOf('day'), 'day');
  if (days === 1) {
    return 'Yesterday';
  }
  if (days < 7) {
    return `${days} days ago`;
  }
  return atDjs.format(atDjs.isSame(nowDjs, 'year') ? 'D MMM' : 'D MMM YYYY');
}
